namespace GeniuzPOS.Administration {
    export interface SysGroupRow {
        Id?: number;
        SysGroup?: string;
        SysGroupDesc?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace SysGroupRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysGroup';
        export const localTextPrefix = 'Administration.SysGroup';
        export const lookupKey = 'Administration.SysGroup';

        export function getLookup(): Q.Lookup<SysGroupRow> {
            return Q.getLookup<SysGroupRow>('Administration.SysGroup');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            SysGroup = "SysGroup",
            SysGroupDesc = "SysGroupDesc",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
